export default __webpack_public_path__ + "static/illu_scooter_circle-4b61e209308e40ba9f930410f542c1bb.svg";